/** Elastic field path for turn analysis events on call-history documents. */
export const ANALYTIC_EVENTS_PATH = 'output.analytic_events';

export const ANALYTIC_EVENTS_DATA_PATH = `${ANALYTIC_EVENTS_PATH}.data`;
